import styled, { keyframes } from 'styled-components';

import { avatarSizePx } from '@pkg/components';
import { styledLayout, styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './tokens';
import { type StatsCardAvatarSize } from './types';

interface StatsCardWrapperProps {
    $large: boolean;
}

interface AvatarWrapperProps {
    $size: StatsCardAvatarSize;
}

interface TypographyProps {
    $large: boolean;
}

// TODO: Duplicated from <Avatar />.
const loadingShine = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

export const StatsCardWrapper = styled.div<StatsCardWrapperProps>`
    --yat_stats-card-padding: ${({ $large }) => `${tokens.card.padding[$large ? 'large' : 'base']}px`};
    display: grid;
    justify-items: center;
    width: 100%;
    max-width: ${({ $large }) => `${tokens.card.size[$large ? 'large' : 'base']}px`};
    text-align: center;
`;

export const AvatarWrapper = styled.div<AvatarWrapperProps>`
    --yat_stats-card-avatar-size: ${({ $size }) => `${avatarSizePx[$size]}px`};
    position: relative;
    z-index: 1;
    margin-bottom: calc(var(--yat_stats-card-avatar-size) / 6 * -1);
`;

export const Card = styled.div`
    position: relative;
    z-index: 2;
    display: grid;
    width: 100%;
    padding: var(--yat_stats-card-padding);
    background-color: ${({ theme }) => theme.shades.white[10]};
    border-radius: 16px;

    @supports (backdrop-filter: blur(1px)) {
        backdrop-filter: blur(40px);
    }
`;

export const Title = styled.span<TypographyProps>`
    // TODO: This element should use a heading tag.
    --yat_stats-card-title-font-size: ${({ $large }) => `${tokens.title.fontSize[$large ? 'large' : 'base']}px`};
    ${styledReset.typography};
    position: relative;
    margin-bottom: 0.6em;
    font-family: ${({ theme }) => theme.fonts.alliance};
    font-size: var(--yat_stats-card-title-font-size);
    font-weight: 700;
    letter-spacing: -1px;
    color: ${({ theme }) => theme.colors.white};

    &:empty {
        height: var(--yat_stats-card-title-font-size);
        // TODO: Formalize this "skeleton block" into the design system.
        background: linear-gradient(134deg, rgba(255, 255, 255, 0.1), transparent);
        border-radius: 6px;
        overflow: hidden;

        &::before {
            ${styledLayout.positionCover()}
            content: '';
            background-color: ${({ theme }) => theme.shades.white[5]};
            animation: ${loadingShine} 600ms ease-in-out alternate infinite both;
        }
    }
`;

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding-left: ${tokens.card.padding.base}px;
    padding-right: ${tokens.card.padding.base}px;
`;

export const Item = styled.li`
    display: grid;
`;

export const ItemValue = styled.span<TypographyProps>`
    ${styledReset.typography};
    font-family: ${styledTypography.tuskerFontStack};
    font-size: ${({ $large }) => `${tokens.itemValue.fontSize[$large ? 'large' : 'base']}px`};
    letter-spacing: -1px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.white};
`;

export const ItemLabel = styled.span<TypographyProps>`
    ${styledReset.typography};
    margin-top: 0.4em;
    font-family: ${styledTypography.tuskerFontStack};
    font-size: ${({ $large }) => `${tokens.itemLabel.fontSize[$large ? 'large' : 'base']}px`};
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.shades.white[50]};
`;
